import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATUlEQVR42m2Nyw2AIBAF6b8S4hGLwADBMvCAHezuGPwcjM7hvcsk47hRNX4QN9bMSKlQ60rOhda2tzDofSeEGe8nYly+wpVRROT8RzgApId6fwVQNQkAAAAASUVORK5CYII="};
